import Banner from "./Banner";
import Cities from "./Cities";
import News from "./News";
import Process from "./Process";
import Services from "./Services";
import Stats from "./Stats";
import Partners from "./Partners";

export default function Home() {
  return (
    <>
      {/* 横幅 */}
      <Banner />

      {/* 数据统计 */}
      <Stats />

      {/* 服务介绍 */}
      <Services />

      {/* 流程步骤 */}
      <Process />

      {/* 业务动态 */}
      <News />

      {/* 入驻城市 */}
      <Cities />

      {/* 合作伙伴 */}
      <Partners />
    </>
  );
}
